import { Backdrop, CircularProgress } from "@material-ui/core";
import React, { FC } from "react";

import { useStyles } from "./styles";

interface ExportAllBackdropProps {
  isOpen: boolean;
}

const ExportAllBackdrop: FC<ExportAllBackdropProps> = ({ isOpen }) => {
  const classes = useStyles({});
  return (
    <Backdrop className={classes.backdrop} open={isOpen}>
      <CircularProgress color="inherit" size={70} />
      <div>Exporting Unlock Codes.</div>
      <div>This might take a while.</div>
    </Backdrop>
  );
};

export default ExportAllBackdrop;
